<!-- 绑定微信 -->
<template>
  <div class="other-bind-wx">
    <div>
      <h1>绑定微信</h1>
      <p>随着再来人不断完善自身的服务，为了让您第一时间知道服务进度，我们在公众号上开发了新的功能，能让您在微信上收到最新的服务进度消息提醒。例如：当导师回传了您的项目文书，您将第一时间在微信公众号上收到消息提醒，助您更好的进行项目申请。</p>
      <div class="other-bind-wx-intro">
        具体流程如下：<br />
        1.微信扫描二维码，关注“再来人 小V”公众号；<br />
        2.点击“Mentee”，输入用户名和密码，绑定微信；<br />
        3.此后，您就可以第一时间收到服务平台上的消息；
      </div>
      <div class="other-bind-wx-code">
        <img :src="code"
             alt="再来人二维码">
      </div>
    </div>
  </div>
</template>
<script>
// code
import code from '@/assets/images/other/qrcode.svg'
// less
import './other.less'
export default {
  name: 'other-bind-wx',
  components: {},
  data () {
    return {
      code
    }
  },
  computed: {},
  mounted () { },
  methods: {}
}
</script>
<style lang='less' scoped>
</style>
